import { render } from "./entrynarrow.vue?vue&type=template&id=7c52264c&scoped=true"
import script from "./entrynarrow.vue?vue&type=script&lang=js"
export * from "./entrynarrow.vue?vue&type=script&lang=js"

import "./entrynarrow.vue?vue&type=style&index=0&id=7c52264c&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c52264c"]])

export default __exports__